var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSiteAnalyst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    fill: "#bcc5ea",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{opacity:0.3;fill:none;stroke:#4698CA;enable-background:new    ;}\r\n\t.st3{fill:none;stroke:#4698CA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90,
    y1: 0,
    x2: 90,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130,
    y1: 0,
    x2: 130,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 140,
    y1: 0,
    x2: 140,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 180,
    y1: 0,
    x2: 180,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190,
    y1: 0,
    x2: 190,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 210,
    y1: 0,
    x2: 210,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 220,
    y1: 0,
    x2: 220,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230,
    y1: 0,
    x2: 230,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 0,
    x2: 250,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 260,
    y1: 0,
    x2: 260,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270,
    y1: 0,
    x2: 270,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 280,
    y1: 0,
    x2: 280,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 290,
    y1: 0,
    x2: 290,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 310,
    y1: 0,
    x2: 310,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 10,
    x2: 320,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 20,
    x2: 320,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 30,
    x2: 320,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 40,
    x2: 320,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 50,
    x2: 320,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 60,
    x2: 320,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 70,
    x2: 320,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 80,
    x2: 320,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 90,
    x2: 320,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 100,
    x2: 320,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 110,
    x2: 320,
    y2: 110
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 120,
    x2: 320,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 130,
    x2: 320,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 140,
    x2: 320,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 150,
    x2: 320,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 160,
    x2: 320,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 170,
    x2: 320,
    y2: 170
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 180,
    x2: 320,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 190,
    x2: 320,
    y2: 190
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 200,
    x2: 320,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 210,
    x2: 320,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 220,
    x2: 320,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 230,
    x2: 320,
    y2: 230
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 240,
    x2: 320,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 320,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 260,
    x2: 320,
    y2: 260
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 270,
    x2: 320,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 280,
    x2: 320,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 290,
    x2: 320,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 300,
    x2: 320,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 310,
    x2: 320,
    y2: 310
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304.8,189.4L273.6,171l-99.1,58.4c-4.4,2.6-9.4,3.9-14.5,3.9s-10.1-1.4-14.5-3.9L46.4,171l-31.2,18.4 c-2.9,1.7-4.7,4.8-4.7,8.2s1.8,6.5,4.7,8.2l140,82.5c1.5,0.9,3.2,1.3,4.8,1.3s3.3-0.4,4.8-1.3l140-82.5c2.9-1.7,4.7-4.8,4.7-8.2 S307.7,191.1,304.8,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,130.6l140,82.5c1.5,0.9,3.2,1.3,4.8,1.3s3.3-0.4,4.8-1.3l140-82.5c2.9-1.7,4.7-4.8,4.7-8.2s-1.8-6.5-4.7-8.2 l-140-82.5c-3-1.8-6.7-1.8-9.6,0l-140,82.5c-2.9,1.7-4.7,4.8-4.7,8.2S12.3,128.9,15.2,130.6z M62.2,136.2c5-3.2,12.3-7.8,20.3-12.8 c7.5,3.6,15.3,7.3,21.9,10.6c-6.9,6-13.6,11-20.4,15L62.2,136.2z M146.1,111.7c3.7,1.8,7,4.3,10.1,7.3c-2.7,3.1-5.2,6.3-7.6,9.5 c-3.5,4.5-6.7,8.7-10.3,12.3c-1.3,1.3-2.6,2.6-4,3.8c-5.7-3.8-10.7-7.1-14.4-9.2c-1.4-0.8-3.2-1.8-5.1-2.8c0.7-0.7,1.4-1.3,2.1-2 c3.9-3.9,7.4-8.5,10.9-12.9c2.4-3.1,4.8-6.3,7.4-9.2C139.1,109.1,142.8,110.1,146.1,111.7z M140.1,103.3c2.7-2.5,5.6-4.6,8.8-6.1 c3.3-1.6,6.9-2.6,10.8-3.2c3.9,0.6,7.5,1.7,10.8,3.2c3.3,1.6,6.3,3.8,9.1,6.3c-2.7,0.7-5.2,1.6-7.6,2.8c-4.4,2.1-8.2,5-11.6,8.3 c-3.4-3.3-7.2-6.2-11.6-8.3C146,105,143.1,104,140.1,103.3z M142.4,145.1c3.9-3.9,7.4-8.5,10.9-12.9c2.3-3,4.6-5.9,7-8.8 c2.4,2.8,4.7,5.8,7,8.8c3.4,4.4,7,9,10.9,12.9c0.9,0.9,1.9,1.9,2.8,2.8c-6.8,4.6-14.1,9.7-21,14.5c-6.8-4.8-14-9.8-20.7-14.3 C140.4,147.2,141.4,146.2,142.4,145.1z M172.1,128.6c-2.5-3.2-5-6.4-7.6-9.5c3-3,6.3-5.5,10.1-7.3c3-1.5,6.4-2.5,10-3.1 c2.5,2.9,4.9,6,7.2,9c3.4,4.4,7,9,10.9,12.9c0.8,0.8,1.5,1.5,2.3,2.2c-1.8,1-3.3,1.8-4.7,2.6c-3.6,2.1-8.5,5.3-14.1,9 c-1.2-1.2-2.5-2.3-3.7-3.6C178.8,137.3,175.5,133,172.1,128.6z M196.4,114c-1.5-2-3.1-4-4.7-6c2.4,0,4.9,0.1,7.4,0.4 c4.3,0.5,8.9,0.8,13.9-0.3c5.9,3.6,12.3,7.6,18.5,11.5c-7.4,3.5-14.8,7.1-21,10.3c-1.2-1.2-2.4-2.3-3.7-3.6 C203.2,122.7,199.9,118.5,196.4,114z M199.9,102.5c-4.5-0.6-8.9-0.6-13.1-0.2c-2.8-3-5.9-5.7-9.3-8c3.4,0.2,7.1,0.1,11-1 c2.2,1.2,4.1,2.3,5.7,3.3c2.8,1.6,6.4,3.8,10.5,6.3C203.1,102.8,201.5,102.7,199.9,102.5z M174.3,87.9c-5-0.6-9.9-0.6-14.6,0 c-4.6-0.6-9.5-0.6-14.6,0c-1.6,0.2-3.2,0.4-4.6,0.4c6.1-3.4,13-7.2,19.5-10.8c6.6,3.6,13.5,7.4,19.6,10.8 C177.9,88.3,176.1,88.2,174.3,87.9z M141.9,94.3c-3.4,2.2-6.4,4.9-9.2,7.9c-3.8-0.3-7.9-0.2-12,0.3c-1.9,0.2-3.6,0.4-5.3,0.4 c4.1-2.5,7.7-4.7,10.5-6.3c1.5-0.9,3.4-2,5.5-3.2C135.1,94.4,138.6,94.5,141.9,94.3z M121.5,108.4c2.1-0.3,4.1-0.4,6.1-0.4 c-1.6,2-3.2,4-4.7,6c-3.5,4.5-6.7,8.7-10.3,12.3c-1.2,1.2-2.3,2.3-3.5,3.4c-6.1-3.1-13.4-6.7-20.6-10.1c6.3-3.9,12.7-7.9,18.6-11.6 C112.3,109.3,117.1,109,121.5,108.4z M89.9,152.5c6.8-4.2,13.5-9.4,20.2-15.6c2.6,1.4,4.9,2.6,6.7,3.7c3.3,1.9,7.8,4.8,12.9,8.2 c-6.9,6-13.7,11-20.5,15L89.9,152.5z M115,167.3c6.6-4.1,13.2-9.1,19.8-15c6.4,4.3,13.3,9.1,20,13.8c-7.9,5.6-14.8,10.5-18.9,13.5 L115,167.3z M160,193.9L141.5,183c4.6-3.3,11.2-8,18.5-13.2c7.3,5.2,14,9.9,18.5,13.2L160,193.9z M184.2,179.6 c-4.2-3-11.1-7.9-18.9-13.5c6.8-4.7,13.9-9.7,20.3-14c6.6,5.9,13.2,10.9,19.8,15.1L184.2,179.6z M211.2,163.7 c-6.8-4-13.6-9-20.5-15.1c5-3.3,9.3-6.1,12.5-8c1.7-1,3.8-2.2,6.3-3.5c6.8,6.2,13.5,11.3,20.3,15.5L211.2,163.7z M235.7,149.2 c-6.8-4-13.6-9-20.5-15c6.7-3.4,14.6-7.2,22.3-10.8c8,5,15.3,9.6,20.3,12.8L235.7,149.2z M281.3,122.4l-17.6,10.4 c-4.3-2.7-11.5-7.3-19.7-12.4c7.7-3.6,14.6-6.8,19-8.8L281.3,122.4z M256.6,107.9c-5,2.3-11.6,5.3-18.7,8.7 c-5.8-3.6-11.8-7.4-17.5-11c3-1.3,5.7-2.8,8-4.1c3-1.7,5.7-3.5,8.4-5.4L256.6,107.9z M231,92.8c-1.8,1.2-3.7,2.4-5.7,3.5 c-3.1,1.8-7.1,3.9-11.4,5.3c-6.7-4.2-12.7-7.8-16.8-10.2c-0.4-0.3-0.9-0.5-1.4-0.8c2.6-1.2,5-2.5,7-3.6c3.1-1.8,6.1-3.7,8.8-5.7 L231,92.8z M205.9,77.9c-1.9,1.3-4,2.6-6.1,3.8c-2.9,1.7-6.6,3.7-10.6,5.1c-6.5-3.7-14.8-8.2-22.9-12.7c7-3.8,13.3-7.2,17.3-9.4 L205.9,77.9z M160,50.9l17.5,10.3c-4.6,2.5-10.8,5.9-17.5,9.5c-6.7-3.7-12.9-7-17.5-9.5L160,50.9z M136.5,64.8 c4,2.2,10.2,5.5,17.3,9.4c-8.2,4.5-16.5,9.1-23.1,12.8c-4.2-1.4-8-3.5-11-5.2c-2-1.2-4-2.4-5.8-3.6L136.5,64.8z M108.1,81.5 c2.7,1.9,5.5,3.7,8.5,5.5c2.1,1.2,4.6,2.6,7.4,3.8c-0.4,0.2-0.7,0.4-1.1,0.6c-4.1,2.4-10,6-16.6,10.1c-4.2-1.4-8-3.5-11-5.2 c-2.1-1.2-4.1-2.4-6-3.7L108.1,81.5z M83.6,95.9c2.7,1.9,5.6,3.8,8.6,5.6c2.2,1.2,4.8,2.7,7.6,3.9C94,109,87.9,112.9,82,116.5 c-7.1-3.3-13.8-6.4-18.7-8.7L83.6,95.9z M57.1,111.6c4.3,2,11.2,5.2,19,8.8c-8.2,5.2-15.4,9.7-19.7,12.4l-17.6-10.4L57.1,111.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteAnalyst);
export default __webpack_public_path__ + "static/media/Icon_Site_Analyst.50668f99afe71ff528fa16784c6dfc22.svg";
export { ForwardRef as ReactComponent };